import type { AppThunk } from '@core/core/store'

import { markerNamesByFieldActions } from './markerNamesByFields'
import { wellsByFieldActions } from './wellsByFields'

export const clearHotStorageLoadedData = (): AppThunk => dispatch => {
  dispatch(wellsByFieldActions.removeAllFields())
  dispatch(markerNamesByFieldActions.removeAllFields())
}
